import script from "./ChatDrawerItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatDrawerItem.vue?vue&type=script&setup=true&lang=js"

import "./ChatDrawerItem.vue?vue&type=style&index=0&id=0f4350df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f4350df"]])

export default __exports__